export enum TypeEcSplitEnum {
  EC_MASTER = 'EC_PRINCIPAL',
  EC_SELLER = 'EC_SECUNDARIO',
}
